import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: { Username: string; Password: string }) {
   // const baseUrl = '/Login/authenticate';
   console.log(params, "param");
    return api.create("/Login/authenticate", params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { CompanyName: string; Email: string; Password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { Email: string }) {
    const baseUrl = '/forget-password/';
    return api.create(`${baseUrl}`, params);
}

export { login, logout, signup, forgotPassword };
